export { default } from "./TaskEmailTemplate";
